"use strict";

var main = {
    init: function () {

        $("#menu-toogle").on({
            click:function () {
                if($("body").hasClass("pop-up-active")){
                    $("body").removeClass("pop-up-active");
                }
                $(this).toggleClass('open');
                $(".header-wrapper").toggleClass("active");
            }
        });

        $(".legal-warning-link").off("click").on({
            click:function () {
                $("body").addClass("pop-up-active")
            }
        });

        $(".custom-pop-up .inner .close-btn").off("click").on({
            click:function () {
                $("body").removeClass("pop-up-active");
            }
        });

        // $("body").off("click").on({
        //     click:function (event) {
        //         if(!($(event.target).closest("#at15s").length || $(event.target).closest(".custom-share-button").length)){
        //             // $("#at15s").hide();
        //         }
        //     }
        // });

        /*Pace.on('done', function() {
            main.animation();
        });*/

    },
    minHeight: function () {
        function calc () {
            if($(window).width() > 991){
                $(".page-inner").css({
                    minHeight: $(window).height()
                });
            } else {
                $(".page-inner").css("minHeight","auto");
            }

            if($(".main-promo").length && $(window).width() > 991){
                $(".main-promo .promo-inner").css({
                    minHeight: $(window).height()
                });
            }

            if($(".sub-page-banner").length && $(window).width() > 991){
                var subPageBannerHeight = $(".sub-page-banner").outerHeight(true),
                    associationsHeight = $(".associations").outerHeight(true);

                $(".sub-page-banner").next().css({
                    minHeight: $(window).height() - (subPageBannerHeight + associationsHeight)
                });
            } else {
                $(".sub-page-banner").next().css("minHeight","auto");
            }

            if($(".detail-page").length && $(window).width() > 991){
                var associationsHeight = $(".associations").outerHeight(true);
                $(".detail-page").css({
                    minHeight: $(window).height() - associationsHeight
                });
            }
        }

        calc();

        $(window).on("resize", calc);
    },
    carousel:function () {
        $(".news-carousel").owlCarousel({
            margin: 10,
            navText: ["<i class='icon-left-open-1'></i>","<i class='icon-right-open-1'></i>"],
            dots: false,
            responsive:{
                0:{
                    items: 1,
                    nav: false,
                    margin: 20
                },
                560:{
                    items: 2,
                    nav: false,
                    margin: 20
                },
                820:{
                    items: 3,
                    nav: false
                },
                992:{
                    items: 1,
                    nav: true
                }
            }
        })
    },
    dropdown:function () {
        var button = $(".dropdown:not('.new-style') .dropper");
        var content = $(".dropdown:not('.new-style') .dropped");
        var thisOffset = 0;

        $(button).click(function(event) {
            var thisButton = $(this);
            var thisOffset = 0;
            if(thisButton.parents("li").hasClass("selected")) {
                thisButton.parents("li").removeClass("selected");
                thisButton.next(".dropped").stop().slideUp(400);
            } else {
                thisButton.parents(".dropdown").find("li").removeClass("selected");
                thisButton.parents(".dropdown").find(".dropper").next(".dropped").stop().slideUp(400);
                thisButton.parents("li").addClass("selected");
                thisButton.next(".dropped").stop().slideDown(400,function(){
                    if(thisButton.parents(".dropdown").hasClass("scroll")){
                        thisOffset = $(this).parents(".drop").offset().top;
                        if($(window).width()<768){
                            var pay = $(".mobile-header").outerHeight(true);
                            $('html, body').animate({scrollTop: thisOffset - pay});
                        } else {
                            $('html, body').animate({
                                scrollTop: thisOffset
                            });
                        }
                    } else if($(".dropdown li.add-scroll").length){
                        $(".dropdown").addClass("scroll");
                        $(".dropdown li").removeClass("add-scroll");
                    }
                });
            }
        });
        if($(".dropdown li.select-child").length){
            $(".dropdown li.select-child").find(".dropper").trigger("click");
            $(".dropdown li").removeClass("select-child");
        }

    },
    animation:function () {
        if($(window).width() > 992){
            var header = $(".header-wrapper > .inner"),
                line = $(".line"),
                bannerTextLine = $(".highlight.bordered .border"),
                bannerText1 = $(".highlight h1"),
                bannerText2 = $(".highlight p"),
                mainPromo,
                subPage,
                detailPage;

            if($(".main-promo").length){

                var banner = $(".main-promo .promo-inner"),
                    bottomLogo = $(".vertical-list.v1"),
                    carousel = $(".news-carousel-content");

                var mainPromo = new TimelineMax()
                mainPromo.fromTo(header, 2, {x:-50, opacity:0},{x: 0, opacity:1, ease: Power2.easeOut})
                    .fromTo(banner, 2, {opacity:0, scale:1.3},{opacity:1, scale:1, ease: Power2.easeOut},"-=2")
                    .to(line, 1,{top:0, bottom:0, ease: Power2.easeOut},"-=1")
                    .fromTo(bannerText1, 1.2, {y:50, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},"-=0.7")
                    .fromTo(bannerText2, 1.2, {y:50, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},"-=0.7")
                    .fromTo(bannerTextLine, 0.7, { width:"0px"},{width: "93px", ease: Power2.easeOut},"-=0.7")
                    .fromTo(bottomLogo, 1.2, {y:20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},"-=0.7")
                    .fromTo(carousel, 1.2, {y:20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},"-=1.2");

            } else if($(".sub-page-banner").length){

                var banner = $(".sub-page-banner .inner"),
                    description = $(".description"),
                    verticalListv2 = $(".vertical-list.v2 li"),
                    verticalListv3 = $(".vertical-list.v3 li"),
                    contact = $(".contact"),
                    dropdown = $(".dropdown li");

                var subPage = new TimelineMax()
                subPage.fromTo(header, 1.5, {x:-50, opacity:0},{x: 0, opacity:1, ease: Power2.easeOut})
                    .fromTo(banner, 1.5, {opacity:0, scale:1.3},{opacity:1, scale:1, ease: Power2.easeOut},"-=1.5")
                    .to(line, 1,{top:0, bottom:0, ease: Power2.easeOut},"-=1")
                    .fromTo(bannerText1, 1, {y:50, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},"-=0.5")
                    .fromTo(bannerTextLine, 0.7, { width:"0px"},{width: "93px", ease: Power2.easeOut},"-=0.5")
                    .fromTo(description, 1, {y:-20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},"-=0.5");

                if(contact.length){
                    TweenMax.fromTo(contact, 1, {y:-20, opacity:0},{y:0, opacity:1, delay: 1.5, ease: Power2.easeOut})
                }

                if(verticalListv2.length){
                    TweenMax.staggerFromTo(verticalListv2, 2, {y:40, opacity:0},{y:0, opacity:1, delay:2, ease: Power2.easeOut},0.1);
                }
                if(dropdown.length){
                    TweenMax.staggerFromTo(dropdown, 1.5, {y:-20, opacity:0},{y:0, opacity:1, delay:1.5, ease: Power2.easeOut},0.1);
                }
                if(verticalListv3.length){
                    TweenMax.staggerFromTo(verticalListv3, 1.5, {y:-20, opacity:0},{y:0, opacity:1, delay:2, ease: Power2.easeOut},0.1);
                }

            } else if($(".detail-page").length){
                var detailpage = $(".detail-page");
                var detailPage = new TimelineMax()
                detailPage.fromTo(header, 2, {x:-50, opacity:0},{x: 0, opacity:1, ease: Power2.easeOut})
                    .fromTo(detailpage, 1, {y:-20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},"-=1")
                    .to(line, 1,{top:0, bottom:0, ease: Power2.easeOut},"-=0.5");
            }
        }
    },
    totalAnimation:function () {
        if($(window).width() > 992){
            var header = $(".header-wrapper > .inner"),
                line = $(".line"),
                bannerTextLine = $(".highlight.bordered .border"),
                bannerText1 = $(".highlight h1"),
                bannerText2 = $(".highlight p"),
                mainPromo,
                subPage,
                detailPage;

            if($(".main-promo").length){

                var banner = $(".main-promo .promo-inner"),
                    bottomLogo = $(".vertical-list.v1"),
                    carousel = $(".news-carousel-content");

                TweenMax.fromTo(header, 2, {x:-50, opacity:0},{x: 0, opacity:1, ease: Power2.easeOut})
                TweenMax.fromTo(banner, 2, {opacity:0, scale:1.3},{opacity:1, scale:1, ease: Power2.easeOut})
                TweenMax.to(line, 1,{top:0, bottom:0, ease: Power2.easeOut})
                TweenMax.fromTo(bannerText1, 1.2, {y:50, opacity:0},{y:0, opacity:1, ease: Power2.easeOut})
                TweenMax.fromTo(bannerText2, 1.2, {y:50, opacity:0},{y:0, opacity:1, ease: Power2.easeOut})
                TweenMax.fromTo(bannerTextLine, 0.7, { width:"0px"},{width: "93px", ease: Power2.easeOut})
                TweenMax.fromTo(bottomLogo, 1.2, {y:20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut})
                TweenMax.fromTo(carousel, 1.2, {y:20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut});




            } else if($(".sub-page-banner").length){

                var banner = $(".sub-page-banner .inner"),
                    description = $(".description"),
                    verticalListv2 = $(".vertical-list.v2 li"),
                    verticalListv3 = $(".vertical-list.v3 li"),
                    contact = $(".contact"),
                    dropdown = $(".dropdown li");

                TweenMax.fromTo(header, 1.5, {x:-50, opacity:0},{x: 0, opacity:1, ease: Power2.easeOut});
                TweenMax.fromTo(banner, 1.5, {opacity:0, scale:1.3},{opacity:1, scale:1, ease: Power2.easeOut});
                TweenMax.to(line, 1,{top:0, bottom:0, ease: Power2.easeOut});
                TweenMax.fromTo(bannerText1, 1, {y:50, opacity:0},{y:0, opacity:1, ease: Power2.easeOut});
                TweenMax.fromTo(bannerTextLine, 0.7, { width:"0px"},{width: "93px", ease: Power2.easeOut});
                TweenMax.fromTo(description, 1, {y:-20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut});



                if(contact.length){
                    TweenMax.fromTo(contact, 1, {y:-20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut})
                }

                if(verticalListv2.length){
                    TweenMax.staggerFromTo(verticalListv2, 2, {y:40, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},0.1);
                }
                if(dropdown.length){
                    TweenMax.staggerFromTo(dropdown, 1.5, {y:-20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},0.1);
                }
                if(verticalListv3.length){
                    TweenMax.staggerFromTo(verticalListv3, 1.5, {y:-20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut},0.1);
                }

            } else if($(".detail-page").length){

                var detailpage = $(".detail-page");

                TweenMax.fromTo(header, 2, {x:-50, opacity:0},{x: 0, opacity:1, ease: Power2.easeOut})
                TweenMax.fromTo(detailpage, 1, {y:-20, opacity:0},{y:0, opacity:1, ease: Power2.easeOut})
                TweenMax.to(line, 1,{top:0, bottom:0, ease: Power2.easeOut});

            }
        }
    }
};


$(function() {
	main.init();
	main.carousel();
	main.minHeight();
	main.dropdown();
});